export const METRO_COLORS = {
  primary: "rgb(105, 190, 40)", // Verde Pantone 368 C
  black: "rgb(0, 0, 0)", // Negro Pro.Black C
  white: "rgb(255, 255, 255)", // Blanco

  // Estados de eventos
  status: {
    abierto: "#faad14", // Amarillo
    ejecutando: "#1890ff", // Azul
    falsa_alarma: "#ff4d4f", // Rojo
    validado: "#52c41a", // Verde
    default: "rgb(128, 135, 136)",
  },
};
